import { render, staticRenderFns } from "./AnswersDisplay.vue?vue&type=template&id=569ed362&scoped=true&"
import script from "./AnswersDisplay.vue?vue&type=script&lang=js&"
export * from "./AnswersDisplay.vue?vue&type=script&lang=js&"
import style0 from "./AnswersDisplay.vue?vue&type=style&index=0&id=569ed362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569ed362",
  null
  
)

export default component.exports